import { render, staticRenderFns } from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=template&id=0d2e2de8&scoped=true"
import script from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=script&lang=js"
export * from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MesaObrasCopiaDePlanoNewOrEdit.vue?vue&type=style&index=0&id=0d2e2de8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2e2de8",
  null
  
)

export default component.exports